// eslint-disable-next-line import/no-anonymous-default-export
export default '.widget-header-style { display: none !important; }';
